import React from 'react';
import styled from 'styled-components';

import { setRouteTypeColors, setRouteTypes } from 'consts/vehicles';

import { RType } from 'types/vehicles';

const StyledRouteType = styled.div<{ type: RType }>`
  display: flex;
  position: relative;
  padding-left: 12px;
  text-align: center;
  max-height: 20px;
  line-height: 20px;

  :before {
    content: '';
    display: block;
    position: absolute;
    transform: translateY(-50%);
    top: 50%;
    left: 0;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${(props) => setRouteTypeColors()[props.type]};
  }
`;

const RouteType: React.FC<{ type: RType}> = ({
  type,
}) => {
  const routeTypes = setRouteTypes();
  return <StyledRouteType type={type}>{routeTypes[type]}</StyledRouteType>;
};

export default RouteType;
